import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ReturnObject } from '../../models/returnObject';
import { APIService } from '../api.service';

@Injectable()
export class SystemUnavailService {

    constructor(private api: APIService) {}

    getAvailMessage(): Observable<ReturnObject<string>> {
        return this.api.getAPI(`systemunavail`);
    }
}
